// extracted by mini-css-extract-plugin
export default {"container":"Onboarding_container__X61ln","modal":"Onboarding_modal__pHJcw"};